<template>
  <div>
    <div
      class="bg-white p-3 rounded my-2"
      v-for="(agenda, index) in lista"
      :key="index"
    >
      <div class="row">
        <div class="col-md-3">
          <div class="label">Espaço</div>
          <div class="value">{{ agenda.espaco }}</div>
        </div>
        <div class="col-md-3">
          <div class="label">{{ agenda.tipoEvento }}</div>
          <div class="value">{{ agenda.evento }}</div>
        </div>
        <div class="col-md-3 col-lg-3">
          <div class="label">Responsável</div>
          <div class="value">{{ agenda.responsavel }}</div>
        </div>
        <div class="col-md-3 col-lg-3">
          <div class="label">Intervalo de uso</div>
          <div class="simple-value">{{ agenda.intervalo }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Lista",
  props: {
    lista: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.4;
}
.value {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
.simple-value {
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
